// Header — back arrow / centered title (+ optional sub) / right-side action.
// Per docs/design-spec.md §2.

export default function Header({ title, sub, onBack, action }) {
  return (
    <div className="lc-header">
      {onBack ? (
        <button className="lc-header-back" onClick={onBack} aria-label="Back">
          <svg width="11" height="18" viewBox="0 0 11 18" fill="none">
            <path d="M9.5 1L1.5 9L9.5 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      ) : (
        <span className="lc-header-back" aria-hidden="true" />
      )}
      <div className="lc-header-title">
        {title}
        {sub && <span className="lc-header-sub">{sub}</span>}
      </div>
      {action ? (
        <button className="lc-header-action" onClick={action.onClick} aria-label={action.ariaLabel || 'Action'}>
          {action.icon}
        </button>
      ) : (
        <span className="lc-header-action" aria-hidden="true" />
      )}
    </div>
  );
}

// A search-glass icon for use as an action.
export const SearchIcon = (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="11" cy="11" r="7" />
    <path d="M16 16l5 5" />
  </svg>
);

// A share / send-arrow icon.
export const ShareIcon = (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8" />
    <path d="M16 6l-4-4-4 4" />
    <path d="M12 2v14" />
  </svg>
);
